import React from 'react';
import {DropdownButton, MenuItem, Table} from 'react-bootstrap';
import PropTypes from 'prop-types';
import TablePager from './TablePager';

class ItemList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      maxPageItems: {value: 5, label: '5'},
    };
  }

  handleMaxItemsChange = maxPageItems => {
    this.setState({maxPageItems});
    const maxPage = Math.ceil(this.props.items.length / maxPageItems.value);
    if(this.state.activePage > maxPage){
      this.setState({activePage: maxPage});
    }
  };

  changePage = (pageNum) => {
    this.setState({activePage: pageNum});
  };

  getTable = (items) => {
    let showDropdown = this.props.options.goToItemDashboard
      || this.props.options.editItem
      || this.props.options.deleteItem;

    return(
      <Table responsive data-cy="item-table">
        <thead className="text-primary">
        <tr>
          {
            this.props.options.tableHeaders.map((header, i) => {
              return (
                <th key={i}>{header}</th>
              );
            })
          }
          <th/>
        </tr>
        </thead>
        <tbody>
        {
          items.map((item, index) => {
            return (
              <tr key={item.id} className="item">
                {
                  this.props.options.tableData.map((td, index) => {
                    return (index === 0 && this.props.options.goToItemDashboard)
                      ? <td className="h4" key={td}><a style={{cursor: 'pointer'}} onClick={() => {this.props.options.goToItemDashboard(item);}}>{item[td]}</a></td>
                      : <td className="h4" key={td}>{item[td] || '--'}</td>;
                  })
                }
                <td align="right">
                  {
                    showDropdown &&
                    <DropdownButton
                      data-cy="item-dropdown"
                      id="item-dropdown"
                      title={<i className="fas fa-chevron-down"/>}
                      noCaret={true}
                      pullRight
                    >
                      {
                        this.props.options.goToItemDashboard &&
                        <MenuItem data-cy="item-dashboard-button" onSelect={() => this.props.options.goToItemDashboard(item)}>Dashboard</MenuItem>
                      }
                      {
                        this.props.options.editItem &&
                        <MenuItem data-cy="edit-item-button" onSelect={() => this.props.options.editItem(item)}>Edit</MenuItem>
                      }
                      {
                        this.props.options.deleteItem && (
                          <MenuItem data-cy="delete-item-button" onSelect={() => this.props.options.deleteItem(item)}>Delete</MenuItem>
                        )

                      }
                    </DropdownButton>
                  }
                </td>
              </tr>
            );
          })
        }
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <TablePager data={this.props.items} dataTable={this.getTable}/>
    );
  }
}

ItemList.propTypes = {
  options: PropTypes.shape({
    tableData: PropTypes.array.isRequired,
    tableHeaders: PropTypes.array.isRequired,
    editItem: PropTypes.func,
    deleteItem: PropTypes.func,
    goToItemDashboard: PropTypes.func
  }).isRequired,
  items: PropTypes.array.isRequired,
};

export default ItemList;



// WEBPACK FOOTER //
// ./src/components/ItemList.js